"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.battery = void 0;
const free_solid_svg_icons_1 = require("@fortawesome/free-solid-svg-icons");
const VariableName_1 = require("../VariableName");
exports.battery = {
    __basic_data_type: true,
    __variable_name_data_type: true,
    id: 'battery',
    variableName: VariableName_1.VariableName.battery,
    title: 'Battery',
    icon: free_solid_svg_icons_1.faBatteryHalf,
    isSlotted: true,
    order: 8,
    colormap: [
        { value: 0, rgb: [231, 59, 75, 1] },
        { value: 10, rgb: [220, 190, 25, 1] },
        { value: 20, rgb: [220, 190, 25, 1] },
        { value: 30, rgb: [98, 170, 16, 1] },
        { value: 100, rgb: [98, 200, 16, 1] },
    ],
    unit: `%`,
    dataPointConverter: value => value,
    decimals: 0,
};
//# sourceMappingURL=battery.js.map